import { useSalesChannelCategoriesQuery } from "@/generated/graphql";
import { useMemo } from "react";

export interface SalesChannelCategoryRow {
	salesChannelCategoryID: string;
	salesChannelCategoryGroupID: string;
	salesChannelCategoryName: string;
	displayOrder: number;
	isActive: boolean;
	isInMenu: boolean;
}

export const useSalesChannelCategoryList = (groupID: string | undefined) => {
	const options = useMemo(
		() => ({
			variables: {
				qop: {
					pagination: { page: 1, pageSize: 200, withCount: false },
					sorts: [{ field: "display_order", direction: "asc" }],
					filters: { salesChannelCategoryGroupID: groupID ?? null },
				},
			},
			pause: !groupID,
			requestPolicy: "network-only" as const,
			context: { suspense: false },
		}),
		[groupID],
	);

	const [result, refetch] = useSalesChannelCategoriesQuery(options);

	return {
		items: result.data?.salesChannelCategories.items ?? [],
		fetching: result.fetching,
		error: result.error,
		refetch: () => refetch({ requestPolicy: "network-only" }),
	};
};
